import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { ToastsManager } from "@app/shared/util/toastr.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-report-download-form',
    templateUrl: './report-download-form.component.html',
    styleUrls: ['./report-download-form.component.scss']
})
export class ReportDownloadFormComponent implements OnInit {

    @Input() tableConfig: TableConfig;
    @Input() isLoading: boolean;
    @Input() downloadButtonText: string;
    @Input() appendTo = '';
    @Input() outputDateFormat: 'timestamp' | 'dd/MM/YYYY HH:mm:ss' = 'timestamp';

    @Output() filterChange = new EventEmitter<any>();
    @Output() reportDownload = new EventEmitter<any>();

    reportFilters = [];

    reportDownloadForm: UntypedFormGroup;
    showValidations = false;

    static dateValidator(group: UntypedFormGroup) {
        const startDate = group.controls['startDate'];
        const endDate = group.controls['endDate'];

        if (startDate.value && endDate.value) {
            if (startDate.value > endDate.value) {
                startDate.setErrors({invalidDateInterval: true});
                return;
            }
        }

        if (startDate.hasError('invalidDateInterval')) {
            startDate.setErrors(null);
        }
    };

    constructor(private toastr: ToastsManager, private translationService: TranslateService) {
    }

    ngOnInit() {
        this.onFormInit();
    }

    onFormInit() {
        this.reportDownloadForm = new UntypedFormGroup({
            'startDate': new UntypedFormControl(null),
            'endDate': new UntypedFormControl(null)
        }, ReportDownloadFormComponent.dateValidator.bind(this));
    }

    onDateChange(field: string, value: string) {
        const dateFilter = {
            field: field,
            value: value
        };

        // TODO can't lodash unionBy be used to simplify logic? There must be a way :D
        const filter = this.reportFilters.find(fltr => fltr.field === dateFilter.field);
        const filterIndex = this.reportFilters.indexOf(filter);

        if (filterIndex === -1) {
            if (dateFilter.value) {
                this.reportFilters.push(dateFilter);
            }
        } else {
            if (dateFilter.value) {
                this.reportFilters[filterIndex].value = dateFilter.value;
            } else {
                this.reportFilters.splice(filterIndex, 1);
            }
        }

        if (this.reportDownloadForm.controls['startDate'].hasError('invalidDateInterval')) {
            this.showValidations = true;
        }

        this.filterChange.emit(this.reportFilters);
    }

    onReportDownload() {
        if (this.reportDownloadForm.invalid) {
            this.showValidations = true;
            return;
        }
        if (!this.tableConfig.pager.count) {
            this.toastr.error(this.translationService.instant('reportDownloadForm.toasts.noEntriesError'));
            return;
        }
        this.showValidations = false;
        this.reportDownload.emit(this.tableConfig);
    }

    control(name: string) {
        return this.reportDownloadForm.get(name) as FormControl;
    }
}
